<template>
  <div>
    <form @submit.prevent="submitForm">
      <div id="exampleInputEmoji">
        <v-layout row wrap>
          <!-- <input type="text" v-model="valueInput" /> -->
          <v-flex xs10 md11>
            <textarea
              v-model="valueInput" 
              :class="`textarea ${isMobile ? 'mx-0' : 'mx-2'}`" 
              placeholder="Ingresa tus comentarios aquí. Por temas de seguridad, no está permitido agregar links."
            ></textarea>
            <span :class="`${isMobile ? 'mx-0' : 'ml-2'}`">
              {{ totalCharacter }} / 250
            </span>
            <span 
              class="ml-2 span-alert" 
              v-if="totalCharacter > 250"
            >
              Sólo se permiten 250 caracteres como máximo.
            </span>
          </v-flex>
          <v-flex :class="`${isMobile ? 'pl-0' : 'pl-2'} xs1 mt-2`">
            <v-btn flat outline color="#C9C9C9" fab small class="emoji-button" @click="toogleDialogEmoji">
              😃
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout :class="`${isMobile ? 'row wrap' : 'justify-space-between'}`">
          <v-flex xs12 sm12 md3 class="text-sm-left font-weight-bold text--primary">
            <v-btn type="submit" color="success" :disabled="!valueInput.length">
              Comentar
            </v-btn>
          </v-flex>
          <v-flex xs12 sm12 md5>
            <VEmojiPicker
              :class="`${isMobile ? '' : 'j-emoji-picker'}`"
              v-show="showDialog"
              @select="onSelectEmoji"
              :i18n="i18n"
              :customCategories="customCategories"
              :customEmojis="customEmojis"
            />
          </v-flex>
        </v-layout>
      </div>
    </form>
  </div>
</template>
<script>
import { VEmojiPicker, categoriesDefault, emojisDefault } from "v-emoji-picker";
import { mapActions, mapState, mapMutations } from "vuex";
import { customEmojisSecurity } from "@/utils/emojis/index.js"

export default {
  components: { VEmojiPicker },
  data() {
    return {
      showDialog: false,
      valueInput: "",
      i18n: {
        search: "Buscar...",
        categories: {
          Activity: "Atividades",
          Foods: "Comida",
          Activity: "Actividad",
          Objects: "Objetos",
          Nature: "Naturaleza",
          Peoples: "Personas",
          Symbols: "Símbolos",
          Places: "Lugares",
        },
      },
    };
  },
  props: {
    postSlug: { type: String, required: true },
  },
  computed: {
    ...mapState("user", ["current_user"]),
    customCategories() {
      const categories = ["Activity", "Foods", "Objects", "Nature", "Peoples", "Symbols", "Places"]
      const filteredResults = categoriesDefault.filter((item) =>
        categories.some((cat) => item.name === cat)
      )
      return filteredResults;
    },
    customEmojis() {
      const natureEmojis = this.getEmojisByCategory("Nature")
      const foodsEmojis = this.getEmojisByCategory("Foods")
      const activityEmojis = this.getEmojisByCategory("Activity")
      const placesEmojis = this.getEmojisByCategory("Places")
      return [].concat(natureEmojis, foodsEmojis, activityEmojis, placesEmojis, customEmojisSecurity)
    },
    totalCharacter() {
      return this.valueInput.length
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    ...mapActions("comments", ["createComment", "fetchComments"]),
    ...mapMutations("posts", ["setComment"]),
    getEmojisByData(data) {
      return emojisDefault.filter((item) =>
        data.some(emoji => item.data === emoji.data)
      )
    },
    getEmojisByCategory(category) {
      return emojisDefault.filter((item) => item.category === category)
    },
    toogleDialogEmoji() {
      this.showDialog = !this.showDialog;
    },
    onSelectEmoji(emoji) {
      this.valueInput += emoji.data;
      // Optional
      this.toogleDialogEmoji();
    },
    async submitForm() {
      if (this.totalCharacter > 250) return
      await this.createComment({
        slug: this.postSlug,
        content: this.valueInput,
      });
      this.valueInput = "";
      this.showDialog = false;
      this.$emit("set-page", 1)
      this.fetchComments({ slug: this.postSlug, page: 1 });
    },
  },
};
</script>
<style scoped>

.v-text-field--outlined >>> fieldset {
  border-color: rgba(192, 0, 250, 0.986);
}
#exampleInputEmoji {
  position: relative;
}

.your-input-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.span-alert {
  color: #ff5252
}

.j-emoji-picker {
  position: absolute;
  top: -184px;
  right: 60px;
}

.textarea {
  width: 100%;
  min-height: 80px;
  outline: none;
  box-shadow: none;
  padding: 10px 28px 10px 10px;
  font-size: 15px;
  border: 1px solid #c9c9c9;
  color: #333;
  border-radius: 4px;
  box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.1) inset;
  resize: vertical;
}

.emoji-button {
  border-radius: 4px;
  padding: 0px;
  font-size: 22px;
}
</style>